import {Input} from 'antd'
import FieldsFactory from 'components/form/FieldsFactory'
import FormActionBar from 'components/form/FormActionBar'
import {Formik} from 'formik'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useMemo} from 'react'
import {NullAsDefault, shallowDiff} from 'views/Shared'
import {createControlledFormField} from '../factory/createFormField'

const formSchema = {
  key: {
    title: 'title',
    children: [
      {
        name: 'key',
        component: createControlledFormField({
          placeholder: 'title',
          addonBefore: '#',
        }),
      },
    ],
  },
  text_content: {
    title: 'content',
    children: [
      {
        name: 'text_content',
        component: createControlledFormField({
          row: 3,
          placeholder: 'content',
          Component: Input.TextArea,
        }),
      },
    ],
  },
}

export const InsertNotes = ({
  isLoading,
  onSubmit = NullAsDefault,
  onCancel = NullAsDefault,
}) => {
  const t = useTranslate()

  const validate = (values) => {
    let errors = {}
    _.forEach(['key', 'text_content'], (name) => {
      const value = _.get(values, name)
      if (_.isEmpty(value ?? undefined)) {
        errors[name] = t('required field')
      }
    })
    return errors
  }

  return (
    <Formik
      initialValues={{
        key: undefined,
        text_content: undefined,
      }}
      validate={validate}
      validateOnMount={true}
      validateOnChange={true}
      enableReinitialize={true}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true)
        onSubmit({
          ...values,
          key: '#' + values?.key,
        })
      }}>
      <div className="flex flex-col space-y-2">
        <FieldsFactory formSchema={[formSchema.key, formSchema.text_content]} />
        <FormActionBar
          submitText="create"
          cancelSubmit={isLoading}
        />
      </div>
    </Formik>
  )
}

export const EditNotes = ({
  item,
  isLoading,
  onSubmit = NullAsDefault,
  onCancel = NullAsDefault,
}) => {
  const t = useTranslate()

  const initialValues = useMemo(() => {
    const raw_key = String(item?.key)
    return {
      id: item?.key,
      text_content: item?.text_content,
      key: raw_key.startsWith('#') ? raw_key.slice(1) : raw_key,
    }
  }, [item])

  const validate = (values) => {
    let errors = {}
    _.forEach(['key', 'text_content'], (name) => {
      const value = _.get(values, name)
      if (_.isEmpty(value ?? undefined)) {
        errors[name] = t('required field')
      }
    })
    return errors
  }

  return (
    <Formik
      validate={validate}
      validateOnMount={true}
      validateOnChange={true}
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true)
        const changes = shallowDiff(values, initialValues)
        onSubmit(
          _.omitBy(
            {
              ...(changes ?? {}),
              id: values?.id,
              key: changes?.key ? '#' + changes?.key : undefined,
            },
            _.isUndefined
          )
        )
      }}>
      <div className="flex flex-col space-y-2">
        <FieldsFactory formSchema={[formSchema.key, formSchema.text_content]} />
        <FormActionBar
          submitText="save"
          cancelSubmit={isLoading}
        />
      </div>
    </Formik>
  )
}
